import BaseFeature from '../../foundation/base/base';

// eslint-disable-next-line no-unused-vars
const CONFIG = {
	MIN_HEIGHT: 70,
	SCALE_OFFSET: 0.3,
	TIMEOUT: 3
};

export default class HeroSecondary extends BaseFeature {
	constructor(element) {
		super(element);
		this.el = element;
		this.heroExpanderLabel = this.el.querySelector('[data-js="heroExpanderLabel"]');
		this.heroExpanderTrigger = this.el.querySelector('[data-js="heroExpanderTrigger"]');
		this.accessibility();
	}

	accessibility() {
		// WCAG CHANGES
		window.addEventListener('keyup', (e) => {
			const isFocused = document.activeElement === this.heroExpanderLabel;
			if (isFocused && e.code === 'Enter') {
				e.preventDefault();
				// Trigger the button element with a click
				this.heroExpanderTrigger.click();
			}
		});

		if (this.heroExpanderLabel) {
			this.heroExpanderLabel.classList.add('o-hero-module__expand--hide-outline');

			this.heroExpanderLabel.addEventListener('keyup', (e) => {
				if (e.code === 'Tab') {
					this.heroExpanderLabel.classList.remove('o-hero-module__expand--hide-outline');
				}
			});
		}

		if (this.heroExpanderTrigger) {
			this.heroExpanderTrigger.addEventListener('click', () => {
				this.heroExpanderLabel.classList.add('o-hero-module__expand--hide-outline');
			});
		}
	}
}
